import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TENANT_QUERY_KEY, useTenant } from '../../../contexts/TenantContext';
import useErrorHandler from '../../../hooks/useErrorHandler';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import { COUPONS_QUERY_KEY } from './useGetCoupons';

// Ends a coupon at once, for good. A coupon is never deleted: bookings point at it.
const useCloseCoupon = () => {
  const { tenantId } = useTenant();
  const queryClient = useQueryClient();
  const { handleError } = useErrorHandler();

  const mutation = useMutation({
    mutationFn: (couponId) => apiClient.post(`/v1/tenants/${tenantId}/coupons/${couponId}/close`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: COUPONS_QUERY_KEY, exact: true });
      queryClient.invalidateQueries({ queryKey: TENANT_QUERY_KEY });
    },
    onError: (error) => handleError(error, Routes.DASHBOARD_COUPONS),
  });

  const closeCoupon = (couponId, onSuccess) => mutation.mutate(couponId, { onSuccess });

  return { closeCoupon, isLoading: mutation.isPending };
};

export default useCloseCoupon;
